import { GoogleAdsLanguageGq } from '../../../../../../graphql/projects/models/GoogleAdsLanguageGq';
import { GoogleAdsLocationGq } from '../../../../../../graphql/projects/models/GoogleAdsLocationGq';
import { GoogleAdsRequestTypeGq } from '../../../../../../graphql/projects/models/GoogleAdsRequestTypeGq';
import { GoogleAdWordsProductAndServiceGq } from '../../../../../../graphql/projects/models/GoogleAdWordsProductAndServiceGq';

export interface CreateQuickSearchFormState {
  requestType: GoogleAdsRequestTypeGq | null;
  requestName: string;
  country?: GoogleAdsLocationGq;
  city?: GoogleAdsLocationGq;
  language?: GoogleAdsLanguageGq;
  includeZeroVolume: boolean;
  includeMonths: boolean;
  source: string;
  categories: Partial<GoogleAdWordsProductAndServiceGq>[];
  suggestionsWord?: boolean;
  suggestionsAlphabeticals?: boolean;
  suggestionsNumbers?: boolean;
  suggestionsQuestions?: boolean;
  suggestionsComparisons?: boolean;
  suggestionsPrepositions?: boolean;
  maxCharacters?: number;
}

export const validLongTailLanguages = [
  'Swedish',
  'English',
  'Norwegian',
  'Danish',
  'Finnish',
  'German',
];
